import classNames from "classnames";
import { Control, UseFormGetValues, useController } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useMobile } from "@krea/customer-features/hooks";
import { AppFlowFormValues } from "@krea/customer-features/shared-components/application-form/hooks/useApplicationFlowForm";
import AmountSlider from "@krea/customer-features/shared-components/loan-application-form/fields/amount-slider";
import LoanApplicationFormLayout from "@krea/customer-features/shared-components/loan-application-form-layout";
import { useLoanApplicationFormStore } from "@krea/customer-features/store/loan-application-form/hooks";

const FinancingAmountForm = ({
  control,
  goToPreviousStep,
  goToNextStep,
}: {
  control: Control<AppFlowFormValues>;
  getValues: UseFormGetValues<AppFlowFormValues>;
  currentStep: string;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
}) => {
  const isMobile = useMobile();
  const { t } = useTranslation();

  const setRequestedLoanAmount = useLoanApplicationFormStore(
    (state) => state.setRequestedLoanAmount,
  );

  const {
    field: { value, onChange: onInputChange, onBlur: onInputBlur },
    fieldState,
  } = useController({
    name: "requestedLoanAmount",
    control,
  });

  const onChange = (_: unknown, value: number) => {
    onInputChange(value);
    setRequestedLoanAmount(value);
  };

  const innerForm = (
    <div>
      <div className={classNames("tw-mt-6 tw-mb-4", { "tw-mx-2": !isMobile })}>
        <AmountSlider
          name={"requestedLoanAmount"}
          value={value}
          onInputBlur={onInputBlur}
          setInputValue={onChange}
          errors={fieldState.error?.message}
          touched={fieldState.isTouched}
          isRealEstate={false}
        />
      </div>
    </div>
  );

  return (
    <>
      <LoanApplicationFormLayout
        heading={t("applicationForm.common.financingAmountHeading")}
        innerForm={innerForm}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        hideAdvisorCTABanner
        showPreliminaryBidResult
        disabledNavigationBeforeFormCompletion={
          fieldState.error?.message !== undefined
        }
      />
    </>
  );
};

export default FinancingAmountForm;
